import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=06c31eb9&scoped=true"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=06c31eb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c31eb9",
  null
  
)

export default component.exports